<template>
  <div
    class="nav-item"
    :class="[
      { active: activeLevelThreeId === info.meta.id}
    ]"
    @click="handleClick">
      {{ i18n.t(info.meta.title) }}
    <!-- 菜单热门 -->
    <svg
      v-if="info.hot"
      class="icon"
      aria-hidden="true">
      <use xlink:href="#icon-caidanremen"></use>
    </svg>
  </div>
</template>

<script>
import i18n from '@/lang'

import { mapMutations, mapState } from 'vuex'
export default {
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    },
    infoId: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      i18n
    }
  },
  computed: {
    ...mapState('nav', ['activeLevelThreeId', 'hoverLevelOneIndex', 'levelOneList', 'levelTwoList', 'showMask'])
  },
  methods: {
    ...mapMutations({
      setAll: 'nav/SET_ALL'
    }),
    handleClick () {
      const { name } = this.info
      this.setAll({
        showMask: false
      })
      this.$router.push({
        name
      })
    }
  }
}
</script>

<style lang="less" scoped>
.nav-item {
  position: relative;
  // min-width: 84px;
  cursor: pointer;
  &.nav-item {
    margin-right: 60px;
  }
  .icon {
    position: absolute;
    bottom: 5px;
    right: -35px;
    width: 30px;
    height: 30px;
  }
  &:hover {
    color: @blue;
  }
  &.active {
    color: @blue;
  }
}
</style>
